import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import {
  Home,
  ClipboardList,
  Layers3,
  LogOut,
  ChevronRight,
  ShieldCheck
} from "lucide-react";
import logo from "../../assets/icons/logov2.png";

export default function Sidebar() {
  const { logout } = useContext(AuthContext);

  const menuItems = [
    { to: "/", label: "Dashboard", icon: <Home className="w-5 h-5" /> },
    { to: "/jobs", label: "Tareas / Jobs", icon: <ClipboardList className="w-5 h-5" /> },
    { to: "/processes", label: "Procesos", icon: <Layers3 className="w-5 h-5" /> },
  ];

  return (
    <aside className="bg-slate-900 w-64 h-screen flex flex-col justify-between sticky top-0 shadow-2xl z-40">
      
      <div>
        {/* BRANDING */}
        <div className="p-8 flex items-center gap-3">
          <div className="bg-white/10 p-2 rounded-lg backdrop-blur-sm border border-white/10 group-hover:border-blue-500/50 transition-colors">
            <img src={logo} alt="PRODSYNC" className="w-7 h-7" />
          </div>
          <div>
            <h1 className="text-white font-black text-xl tracking-tight leading-none">
              PROD<span className="text-blue-500">SYNC</span>
            </h1>
            <p className="text-[10px] text-slate-500 uppercase font-bold tracking-[0.2em] mt-1">
              v2.0 OS
            </p>
          </div>
        </div>

        {/* MENÚ DE NAVEGACIÓN */}
        <nav className="mt-4 px-4 space-y-2">
          <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest ml-4 mb-4">
            Gestión de Planta
          </p>
          
          {menuItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center justify-between px-4 py-3 rounded-xl text-sm font-bold transition-all duration-200 group ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-600/20"
                    : "text-slate-400 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <div className="flex items-center gap-3">
                <span className="transition-transform group-hover:scale-110">
                  {item.icon}
                </span>
                {item.label}
              </div>
              <ChevronRight className={`w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity`} />
            </NavLink>
          ))}
        </nav>
      </div>

      {/* SECCIÓN INFERIOR */}
      <div className="p-6">
        {/* Banner de Soporte/Info sutil */}
        <div className="bg-slate-800/50 rounded-2xl p-4 mb-6 border border-white/5">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck className="w-4 h-4 text-emerald-500" />
            <span className="text-xs font-bold text-white tracking-wide">Sistema Seguro</span>
          </div>
          <p className="text-[10px] text-slate-500 leading-relaxed">
            Tu conexión está encriptada y monitoreada en tiempo real.
          </p>
        </div>

        {/* BOTÓN SALIR */}
        <button
          onClick={logout}
          className="flex items-center justify-center gap-3 w-full bg-slate-800 hover:bg-red-600/20 hover:text-red-500 text-slate-400 py-3 rounded-xl font-bold text-sm transition-all border border-white/5 hover:border-red-600/30 active:scale-95"
        >
          <LogOut className="w-4 h-4" /> 
          Finalizar Sesión
        </button>
      </div>
    </aside>
  );
}